import baseService from "./base.service"
export const uploadImage = async (file) => {
  const instance = baseService.service();
  const formData = new FormData();
  formData.append("file", file);

  const response = await instance.post("/upload/image", formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });

  return response.data;
};

